export default __webpack_public_path__ + "static/media/shipment-icon-active.8284dd6e.svg";